import { combineReducers } from 'redux';
import _ from 'lodash';
import {
  LOYALTY_SUBSCRIPTION_PAGE_ON_LOADING,
  LOYALTY_SUBSCRIPTION_HIDE_DETAIL_TRANSACTION_MODAL,
  LOYALTY_SUBSCRIPTION_HIDE_PAYMENT_GATEWAY_ERROR_MODAL,
  LOYALTY_SUBSCRIPTION_SET_FEATURE_PRICE,
  LOYALTY_SUBSCRIPTION_SET_FEATURE_PRICE_PER_MONTHS,
  LOYALTY_SUBSCRIPTION_SET_PENDING_PAYMENT_MESSAGE,
  LOYALTY_SUBSCRIPTION_SET_PENDING_OUTLET_MESSAGE,
  LOYALTY_SUBSCRIPTION_SET_CURRENT_OUTLET_COUNT,
  LOYALTY_SUBSCRIPTION_SET_OUTLETS,
  LOYALTY_SUBSCRIPTION_SET_SUBSCRIPTION_DETAIL,
  LOYALTY_SUBSCRIPTION_SHOW_DETAIL_TRANSACTION_MODAL,
  LOYALTY_SUBSCRIPTION_SHOW_PAYMENT_GATEWAY_ERROR_MODAL,
  LOYALTY_SUBSCRIPTION_SET_SUBSCRIBE_BASIC_BUTTON,
  LOYALTY_SUBSCRIPTION_SET_SUBSCRIBE_PRO_BUTTON,
} from 'actions/customers/loyalty/loyaltySubscription/constant';
import createReducer from 'utils/createReducer';

const currentOutletCount = createReducer(0, {
  [LOYALTY_SUBSCRIPTION_SET_CURRENT_OUTLET_COUNT]: (draft, { payload }) =>
    payload.currentOutletCount,
});

// FIXME entity store
const featurePrice = createReducer(
  {},
  {
    [LOYALTY_SUBSCRIPTION_SET_FEATURE_PRICE]: (draft, { payload }) => {
      const { featureName, featurePrice } = payload;
      draft[featureName] = featurePrice;
    },
  }
);

const featurePricePerMonths = createReducer(
  {},
  {
    [LOYALTY_SUBSCRIPTION_SET_FEATURE_PRICE_PER_MONTHS]: (draft, { payload }) =>
      payload.featurePricePerMonths,
  }
);

const isSubscribeBasicButtonEnabled = createReducer(true, {
  [LOYALTY_SUBSCRIPTION_SET_SUBSCRIBE_BASIC_BUTTON]: (draft, { payload }) =>
    payload.isSubscribeBasicButtonEnabled,
});

const isSubscribeProButtonEnabled = createReducer(true, {
  [LOYALTY_SUBSCRIPTION_SET_SUBSCRIBE_PRO_BUTTON]: (draft, { payload }) =>
    payload.isSubscribeProButtonEnabled,
});

const outletList = createReducer([], {
  [LOYALTY_SUBSCRIPTION_SET_OUTLETS]: (draft, { payload }) => payload.outlets,
});

const pageOnLoading = createReducer(true, {
  [LOYALTY_SUBSCRIPTION_PAGE_ON_LOADING]: (draft, { payload }) =>
    payload.pageOnLoading,
});

// FIXME wrong default type
const pendingOutletMessage = createReducer(null, {
  [LOYALTY_SUBSCRIPTION_SET_PENDING_OUTLET_MESSAGE]: (draft, { payload }) =>
    payload.pendingOutletMessage,
});

// FIXME wrong default type
const pendingPaymentMessage = createReducer(null, {
  [LOYALTY_SUBSCRIPTION_SET_PENDING_PAYMENT_MESSAGE]: (draft, { payload }) =>
    payload.pendingPaymentMessage,
});

const showDetailModal = createReducer(false, {
  [LOYALTY_SUBSCRIPTION_SHOW_DETAIL_TRANSACTION_MODAL]: () => true,
  [LOYALTY_SUBSCRIPTION_HIDE_DETAIL_TRANSACTION_MODAL]: () => false,
});

const showPaymentGatewayErrorModal = createReducer(false, {
  [LOYALTY_SUBSCRIPTION_SHOW_PAYMENT_GATEWAY_ERROR_MODAL]: () => true,
  [LOYALTY_SUBSCRIPTION_HIDE_PAYMENT_GATEWAY_ERROR_MODAL]: () => false,
});

const subscriptionDetail = createReducer(
  {},
  {
    [LOYALTY_SUBSCRIPTION_SET_SUBSCRIPTION_DETAIL]: (draft, { payload }) => {
      for (const detail of payload.subscriptionDetail) {
        detail.properties = _.mapValues(
          _.mapKeys(detail.properties, 'name'),
          'value'
        );
      }

      Object.assign(draft, _.mapKeys(payload.subscriptionDetail, 'name'));
    },
  }
);

export default combineReducers({
  currentOutletCount,
  featurePrice,
  featurePricePerMonths,
  isSubscribeBasicButtonEnabled,
  isSubscribeProButtonEnabled,
  outletList,
  pageOnLoading,
  pendingOutletMessage,
  pendingPaymentMessage,
  showDetailModal,
  showPaymentGatewayErrorModal,
  subscriptionDetail,
});
